import styled from 'styled-components';

const ReadOnlyNotice = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	padding: .5rem;
	background-color: #4A90E2;
	color: #fff;
	opacity: .75;
`;

export {
	ReadOnlyNotice
};
